import { PBKDF2, enc, algo } from 'crypto-js';
export class ShaHasher {
    get options() {
        return this._options;
    }
    constructor(options) {
        this._options = options;
    }
    /**
     * Return the hash as a hexadecimal string
     * @param hashType
     * @param input
     * @param salt
     * @param iterations
     * @param keySize
     */
    static hash(hashType, input, salt, iterations, keySize) {
        let hasher;
        switch (hashType) {
            case 'sha1':
                hasher = algo.SHA1;
                break;
            case 'sha256':
                hasher = algo.SHA256;
                break;
            default:
                throw new Error(`Not implemented hasher: ${hashType}`);
        }
        const key = PBKDF2(input, salt, {
            iterations: iterations,
            keySize: keySize / 8,
            hasher: hasher,
        });
        const result = key.toString(enc.Hex);
        return result;
    }
    hash(input) {
        return ShaHasher.hash(this._options.type, input, this._options.salt, this._options.iterations, this._options.keySize);
    }
}
